import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Tooltip from '@material-ui/core/Tooltip';
import { CopyToClipboard } from 'react-copy-to-clipboard';

// STYLES
import { ShareContainer } from './styles';
import { isStringType } from '@/utility/common';

const Share = props => {
  const { data, copyLink, clickCopylink } = props;
  const [t] = useTranslation();
  const [isCopied, setCopied] = useState(false);

  const handleShareWindow = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    const href = item.link || '';
    const id = item.id || '';

    window.open(
      href,
      id,
      `height=450, width=550, top=${window.innerHeight / 2 - 275}, left=${window.innerHeight / 2 -
        225}, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0`,
    );
  };

  const handleCopyClick = () => {
    clickCopylink();
    setCopied(true);
  };

  const handleMouseLeave = () => {
    setTimeout(() => {
      setCopied(false);
    }, 400);
  };

  return (
    <ShareContainer className="share" {...props}>
      {data.map((item, index) => (
        <li className="share__item" key={index}>
          <Tooltip title={item.title}>
            <a
              id={item.id}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              onClick={e => {
                item.onClick(e);
                handleShareWindow(e, item);
              }}
            >
              {isStringType(item.icon) ? <i className={`icon-${item.icon}`} /> : item.icon}
            </a>
          </Tooltip>
        </li>
      ))}
      {!!copyLink && (
        <li className="share__item share--copy-link" onMouseLeave={handleMouseLeave}>
          <Tooltip title={t(`common.${isCopied ? 'linkCopied' : 'copyLink'}`)}>
            <CopyToClipboard text={copyLink} onCopy={handleCopyClick}>
              <span>
                <i className="icon-link" />
              </span>
            </CopyToClipboard>
          </Tooltip>
        </li>
      )}
    </ShareContainer>
  );
};

Share.defaultProps = {
  data: [],
  black: false,
  copyLink: '',
  clickCopylink: () => {},
};

Share.propTypes = {
  data: PropTypes.array,
  black: PropTypes.bool,
  copyLink: PropTypes.string,
  clickCopylink: PropTypes.func,
};

export default React.memo(Share);
